import React, { useState, useEffect, useRef } from 'react';
import { View } from 'react-native';
import { useToast } from 'react-native-toast-notifications';
// import { useAppDispatch } from '../../../../hooks';
import { Page, BText, DataGrid, DataGridColumn, Drawer, PageTitle, showToast } from '../../../../components';
import { Button, Input, InputRefProps, ButtonContainer } from '../../../../components/Form';
import { UserInputSchema /*MasterAdminStateModel**/ } from '../../../../types';
import stateJson from '../../../../assets/data/stateData.json';
// import getService from '../../../../services/adminStateService';
// import { setLoading } from '../../../../store/portal/portalActions';

export const AdminAdminAddressState = () => {
  type StateObject = {
    id: number;
    name: string;
    code: string;
    status: boolean;
  };

  const toast = useToast();
  // const dispatch = useAppDispatch();

  const [isAddView, setIsAddView] = useState<boolean>(false);
  const [isEditView, setIsEditView] = useState<boolean>(false);
  const inputStateName = useRef<InputRefProps>(null);
  const inputStateCode = useRef<InputRefProps>(null);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [stateName, setStateName] = useState<string>('');
  const [stateCode, setStateCode] = useState<string>('');
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [selectedState, setSelectedState] = useState<any>(null);
  // const [states, setStates] = useState<MasterAdminStateModel[]>([]);
  const [states, setStates] = useState(stateJson);

  // useEffect(() => {
  //   dispatch(setLoading(true));
  //   getService.retrieveStates().then(res => {
  //     dispatch(setLoading(false));
  //     setStates(
  //       res.data.map((row: any) => {
  //         row.value = row.code;
  //         row.label = row.state;
  //         return row;
  //       }),
  //       // .sort((a: any, b: any) => a.label.localeCompare(b.label)),
  //     );
  //   });
  // }, []);

  useEffect(() => {
    setStates(
      stateJson
        .map((row: any) => {
          row.value = row.name;
          row.label = row.name;
          row.sort = row.id;
          return row;
        })
        .sort((a, b) => a.id - b.id),
    );
  }, []);

  useEffect(() => {
    updateInputValue(inputStateName.current, '');
    updateInputValue(inputStateCode.current, '');
  }, []);

  useEffect(() => {
    setSelectedId(selectedId);
  }, []);

  const column: DataGridColumn[] = [
    { label: 'State', key: 'name', width: 100, sortable: true },
    {
      label: 'Status',
      key: 'status',
      width: 100,
      sortable: true,
      dataType: 'boolean',
      cellRender: (item: any) => <BText>{` ${item.status ? 'Active' : 'Inactive'}`}</BText>,
    },
  ];

  const updateInputValue = (element: InputRefProps | null, value: string) => {
    if (element) element.setValue(value);
  };

  const incrementId = () => {
    return isEditView ? selectedId : states[states.length - 1].id + 1;
  };

  const doSaveBtn = async () => {
    // var stateModel: MasterAdminStateModel = {
    //   state: inputStateName.current?.value || '',
    //   code: inputStateCode.current?.value || '',
    // };
    // console.log('stateModel>>>', JSON.stringify(stateModel));
    // let res = await getService.createState(stateModel);
    // console.log('res>>>', res);

    const newState: StateObject = {
      id: incrementId(),
      name: inputStateName.current?.value || '',
      code: inputStateCode.current?.value || '',
      status: true,
    };
    handleAddOrUpdate(newState);
    setIsAddView(false);
    clearInputValue();
  };

  const handleAddOrUpdate = (newState: StateObject) => {
    const existingStateIndex = states.findIndex(state => state.id === newState.id);
    console.log('existingStateIndex>>>', existingStateIndex);

    if (existingStateIndex !== -1) {
      const updatedStateData = [...states];
      updatedStateData[existingStateIndex] = newState;
      setStates(updatedStateData);
    } else {
      setStates(prevData => [...prevData, newState]);
    }
  };

  const doCancelBtn = () => {
    setIsAddView(false);
    setIsEditView(false);
    clearInputValue();
  };

  const showEditItemView = (editSelectedState: any) => {
    setIsAddView(true);
    setIsEditView(true);
    populateSelectedEditItem(editSelectedState);
    setSelectedState(editSelectedState);
    console.log('showEditItemView>>>', editSelectedState);
  };

  const populateSelectedEditItem = (populateSelectedState: any) => {
    console.log('populateSelectedEditItem>>>', populateSelectedState);
    setStateName(populateSelectedState.name);
    setStateCode(populateSelectedState.code);
    setSelectedId(populateSelectedState.id);
  };

  const showDeleteDrawer = (selectedItemIndex: any) => {
    setSelectedState(selectedItemIndex);
    setShowDelete(true);
  };

  const handleDeleteItem = () => {
    const updatedStateData = states.filter(state => state.code !== selectedState.code);
    setStates(updatedStateData);
  };

  const handleActivationItem = (selectedItemIndex: any) => {
    const itemsToSelect = states.map(item => {
      if (selectedItemIndex.code === item.code) {
        return {
          ...item,
          status: !item.status,
        };
      }
      return item;
    }, []);
    setStates(itemsToSelect);
    showToast(toast, {
      message: selectedItemIndex.status
        ? `${selectedItemIndex.name} is disabled`
        : `${selectedItemIndex.name} is enabled`,
    });
  };

  const clearInputValue = () => {
    if (!isAddView) {
      setStateName('');
      setStateCode('');
    }
  };

  return (
    <Page title={'States Setup'}>
      {!isAddView && (
        <View>
          <DataGrid
            data={states}
            columns={column}
            actions={[
              {
                label: 'Active',
                action: (item: any) => handleActivationItem(item),
                disable: (item: any) => item.status,
              },
              {
                label: 'Deactivate',
                action: (item: any) => handleActivationItem(item),
                disable: (item: any) => !item.status,
              },
              {
                label: 'Edit',
                action: (item: any) => showEditItemView(item),
              },
              {
                label: 'Delete',
                action: (item: any) => showDeleteDrawer(item),
                disable: (item: any) => !item.status,
              },
            ]}
            defaultSort={{ key: 'state', direction: 'ascending' }}
            // onDoubleClick={(item: any) => console.log('DblClick', item)}
            onSelect={(item: any) => console.log('select', item)}
            primaryButton={{
              label: 'Add State',
              action: () => setIsAddView(true),
            }}
          />
        </View>
      )}

      {isAddView && (
        <View>
          {!isEditView ? <PageTitle>Add New State</PageTitle> : <PageTitle>Edit State</PageTitle>}
          <Input
            label={'State Name'}
            id="stateName"
            value={!isEditView ? '' : stateName}
            schemaObject={UserInputSchema}
            schemaContext={{ isEdit: true }}
            ref={inputStateName}
          />

          <Input
            label={'State Code'}
            id="stateCode"
            value={!isEditView ? '' : stateCode}
            schemaObject={UserInputSchema}
            schemaContext={{ isEdit: true }}
            ref={inputStateCode}
          />

          <ButtonContainer direction="horizontal">
            <Button onPress={() => doSaveBtn()}>Save</Button>
            <Button onPress={() => doCancelBtn()}>Cancel</Button>
          </ButtonContainer>
        </View>
      )}

      <Drawer
        id="state.delete"
        visible={showDelete}
        type={'onCancel'}
        onClose={() => setShowDelete(false)}
        onOK={handleDeleteItem}
        title={'Confirmation'}
      >
        <BText>Are you confirm to delete the state?</BText>
      </Drawer>
    </Page>
  );
};
